import React, { useState, useEffect } from 'react';
import axios from '../utils/axiosConfig'; // 新增CSRF設定
import { useTranslation } from 'react-i18next';
import API_URL from '../config';
import { toast } from 'react-toastify';

function UpdateLog() {
  const [logs, setLogs] = useState([]); // 更新日誌數據
  const { t } = useTranslation();

  // 初始化日誌數據
  useEffect(() => {
    async function fetchLogs() {
      try {
        const response = await axios.get(`${API_URL}/api/update-logs`, { withCredentials: true });
        setLogs(response.data);
      } catch (error) {
        console.error('Error fetching update logs:', error);
        toast.error(t('fetchLogsError'));
      }
    }
    fetchLogs();
  }, [t]);

  return (
    <div className="bg-gray-100 dark:bg-gray-900 min-h-screen">
      <div
        className="w-full h-64 bg-cover bg-center flex flex-col items-center justify-center text-white text-3xl font-bold"
        style={{ backgroundImage: `url('/images/myReportsBanner.png')` }}
      >
        {t('updateLogs')}
        <p className="text-lg font-medium mt-2">{t('viewUpdateHistory')}</p>
      </div>

      <div className="container mx-auto py-8 px-4">
        {/* 顯示更新日誌 */}
        <div className="bg-white dark:bg-gray-800 rounded-md shadow-md p-6">
          <h2 className="text-2xl font-bold mb-4">{t('updateLogHistory')}</h2>
          {logs.length > 0 ? (
            logs.map((log) => (
              <div key={log._id} className="border-b pb-4 mb-4 last:border-none">
                <h3 className="text-xl font-semibold">{t('version')}: {log.version}</h3>
                <p>{t('description')}: {log.description}</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">{t('updatedOn')}: {new Date(log.date).toLocaleDateString()}</p>
              </div>
            ))
          ) : (
            <p>{t('noLogsFound')}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default UpdateLog;
